import { EControlType, EReportControlId, ERFilterKey, type IControlSettingUI } from '../../type';

import {
  CHART_OPTIONS,
  GENERAL_METRIC_INFO,
  GENERAL_VISUALIZATION_INFO,
  REPORT_METRIC_GROUP,
  REPORT_METRIC_INFO,
  REPORT_METRIC_UI,
  REPORT_VISUALIZATION_GROUP,
  REPORT_VISUALIZATION_INFO,
} from '../constants';
import {
  REPORT_FILTER_GROUP,
  REPORT_FILTER_INFO,
  GENERAL_FILTER_INFO,
  FILTER_SETTING_UI,
} from '../constants/report-filters';
import {
  DIMENSION_GROUP,
  GENERAL_DIMENSION_INFO,
  DIMENSION_UI,
  DIMENSION_INFO,
} from '../constants/dimension';
import {
  THUMB_DIMENSION_FILTER,
  THUMB_REPORT_FILTER,
  THUMB_VISUALIZATION,
} from '~/constants/thumbnail';

export const FILTER_CONTROL_SETTING_UI: IControlSettingUI = {
  id: EReportControlId.FILTER,
  type: EControlType.SECTION_CARD,
  label: 'Filter',
  config: {
    optionsGroup: REPORT_FILTER_GROUP,
    itemInfo: REPORT_FILTER_INFO,
    generalItemInfo: GENERAL_FILTER_INFO,
    controlSettingUI: FILTER_SETTING_UI,
    defaultControls: [FILTER_SETTING_UI[ERFilterKey.DATE]],
    thumbnail: THUMB_REPORT_FILTER,
    searchPlaceholder: 'Search filter',
  },
  controls: [FILTER_SETTING_UI[ERFilterKey.DATE]],
};
export const CONTROL_SETTING_UI: IControlSettingUI[] = [
  {
    id: EReportControlId.METRICS_FILTER,
    type: EControlType.SECTION_CARD,
    label: 'Metrics',
    config: {
      optionsGroup: REPORT_METRIC_GROUP,
      itemInfo: REPORT_METRIC_INFO,
      generalItemInfo: GENERAL_METRIC_INFO,
      controlSettingUI: REPORT_METRIC_UI,
      searchPlaceholder: 'Search metrics',
    },
    connector: {
      key: EReportControlId.METRIC,
    },
  },
  {
    id: EReportControlId.DIMENSIONS_FILTER,
    type: EControlType.SECTION_CARD,
    label: 'Dimensions',
    config: {
      optionsGroup: DIMENSION_GROUP,
      itemInfo: DIMENSION_INFO,
      generalItemInfo: GENERAL_DIMENSION_INFO,
      controlSettingUI: DIMENSION_UI,
      thumbnail: THUMB_DIMENSION_FILTER,
      searchPlaceholder: 'Search dimensions',
    },
    dependentControls: [
      {
        id: EReportControlId.TAB_CAMPAIGN,
      },
    ],
  },
  {
    id: EReportControlId.CHART_FILTER,
    type: EControlType.SECTION_CARD,
    label: 'Chart',
    controls: [
      {
        id: EReportControlId.CHART,
        type: EControlType.SELECT_DROPDOWN,
        options: CHART_OPTIONS,
        defaultValue: CHART_OPTIONS?.[0]?.value,
        config: {
          optionsGroup: REPORT_VISUALIZATION_GROUP,
          itemInfo: REPORT_VISUALIZATION_INFO,
          generalItemInfo: GENERAL_VISUALIZATION_INFO,
          thumbnail: THUMB_VISUALIZATION,
        },
      },
    ],
  },
  FILTER_CONTROL_SETTING_UI,
];
